.eds-card {
  background: var(--eds--color--bg-base);
  border: 1px solid var(--eds--color--border-default);
  border-radius: var(--eds--radii-8);
}

.eds-card--content {
  overflow: auto;
}

.eds-card--content--size-s {
  padding: var(--eds--padding-none) var(--eds--padding-16);
}

.eds-card--content--size-m {
  padding: var(--eds--padding-16);
}

.eds-card--content--size-l {
  padding: var(--eds--padding-24);
}

/* Content as the card's last row scrolls and paints its own surface — a document
   canvas, a full-bleed table — which would square off the corners the card
   rounds. An embedded card has no radius of its own to follow. */
.eds-card:not(.eds-card--embedded) > .eds-card--content:last-child {
  border-bottom-left-radius: var(--eds--radii-8);
  border-bottom-right-radius: var(--eds--radii-8);
}

/* Host manages the content padding (e.g. to render full-bleed dividers). */
.eds-card--content--no-padding {
  padding: var(--eds--padding-none);
}

/* Borderless: the embedding host (e.g. AppShell's rail) supplies the chrome, so
   the card drops its own outer border, shadow, and radius to avoid doubling. */
.eds-card--embedded {
  border: none;
  box-shadow: var(--eds--elevation-base);
  border-radius: var(--eds--radii-none);
}
